export default (theme) => {
  const {
    pink,
    white,
    primary,
    lightPink,
  } = theme.palette.common
  const { appBarHeight } = theme.global

  const menuLeftSpacing = '0.5rem'

  return {
    appBar: ({ hide }) => {
      const top = hide ? `-${appBarHeight.desktop}` : 0
      return {
        top,
        backgroundColor: white,
        height: appBarHeight.desktop,
        [theme.breakpoints.down('md')]: {
          height: appBarHeight.mobile,
        },
        transition: 'top 0.25s',
      }
    },

    toolbar: {
      [theme.breakpoints.up('lg')]: {
        padding: '0 2.5%',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
      },

      [theme.breakpoints.down('md')]: {
        justifyContent: 'space-between',
        margin: '0rem 1.5rem',
        alignItems: 'center',
        display: 'flex',
      },
    },

    toolbarLeft: {
      [theme.breakpoints.up('lg')]: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
      },
    },

    toolbarRight: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
    },

    toolbarCenter: {
      marginLeft: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },

    dropdownMenu: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-around',
    },

    navigationLink: {
      height: '100%',
      textAlign: 'center',
      boxSizing: 'content-box',
      display: 'block',
      alignItems: 'center',
      margin: theme.spacing(0, 0.4),
      color: 'inherit',
      position: 'relative',
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(1),
        height: 'inherit',
        width: '100%',
      },
    },

    linkContent: {
      display: 'flex',
      alignItems: 'center',
    },

    alignCenter: {
      justifyContent: 'center',
    },

    caret: {
      marginLeft: theme.spacing(0.5),
    },

    menuFocus: {
      color: primary,
    },

    menuDropdown: {
      color: pink,
      padding: `0.35rem ${menuLeftSpacing}`,
      [theme.breakpoints.down('md')]: {
        paddingTop: '0.8rem',
      },
    },

    navigationButton: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '1rem 0',
      [theme.breakpoints.down('md')]: {
        margin: 0,
      },
    },

    authButtons: {
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'center',
      },
    },

    desktopAuthButtons: {
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },

    drawerMenu: {
      [theme.breakpoints.up('lg')]: {
        display: 'none',
      },
    },

    buttonContainer: {
      '&:hover': {
        backgroundColor: theme.palette.common.paleGrey,
        cursor: 'pointer',
      },
    },

    button: {
      margin: '0 0.5rem',
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('md')]: {
        margin: '1.5rem 0 0 0',
      },
    },

    menuButton: {
      '& > button': {
        margin: 0,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },

    languageContainer: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '2rem',
      [theme.breakpoints.down('md')]: {
        marginRight: '1rem',
      },
    },

    languageText: {
      marginLeft: '0.2rem',
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },

    drawerContainer: {
      marginTop: appBarHeight.mobile,
      width: '280px',
      [theme.breakpoints.down('md')]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },

    image: {
      [theme.breakpoints.down('md')]: {
        width: '5rem',
      },
    },

    imageContainer: {
      display: 'flex',
      alignItems: 'center',
    },

    buttonActive: {
      color: primary,
    },

    buttonText: {
      marginLeft: '0.5rem',
      fontSize: '14px',
    },

    menuButtonText: {
      borderRadius: 0,
      fontWeight: 400,
      alignText: 'center',
      fontSize: 14,
      height: '47px',
      color: '#000',
      '&:hover': {
        backgroundColor: pink,
        fontWeight: 700,
      },
    },

    disabledLink: {
      pointerEvents: 'none',
      color: '#000',
    },

    drawer: {
      position: 'fixed',
      zIndex: '5 !important',
      marginRight: '1rem',
    },

    navigationBarButton: {
      fontSize: '14px',
    },

    dropdownItemsWrapper: {
      position: 'absolute',
      marginLeft: menuLeftSpacing,
      padding: '8px 0',
      width: 'max-content',
      //* Animation initial state.
      opacity: 0,
      transform: 'scale(0)',
      transformOrigin: '0px 0px',
    },

    openMenuAnimation: {
      opacity: 1,
      transform: 'none',
      transition: 'opacity 262ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 174ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },

    menuItem: {
      '&:hover': {
        '& > a > p': {
          fontWeight: 700,
        },
        backgroundColor: lightPink,
      },
      padding: '6px 16px',
    },

    linkText: {
      '&::before': {
        //* Pre-occupy the extra width that will be used by the bolded text on hover.
        display: 'block',
        content: 'attr(title)',
        fontWeight: 'bold',
        height: '0',
        overflow: 'hidden',
        visibility: 'hidden',
      },
      fontSize: 14,
      textAlign: 'left',
    },

    activeItem: {
      fontWeight: 700,
    },

    focusVisibleClassName: {
      '&&': {
        backgroundColor: 'unset',
      },
    },
  }
}
